/**
 * Every word on /welcome lives here, so the four layouts share one voice and
 * copy edits never mean touching four files.
 *
 * Rewritten from the live miinews.com homepage. Canonical facts, applied
 * consistently across this file and the CMS bodies:
 *   - founded 1993 → "more than three decades" (the live site's "past 25 years"
 *     and the seed's "40+ yrs" both contradicted its own "Founded in 1993")
 *   - the global medical aesthetic market is a $23 billion industry (the live
 *     homepage's figure; one page said $23.4B — that variant is retired)
 */

export const BRAND = {
  kicker: "Medical Insight",
  title: "Leading the global medical aesthetic market",
  lede: "For more than three decades we have measured and reported on the business of medical aesthetics — giving manufacturers and investors the evidence they need before they commit.",
  short:
    "Market research, strategic consulting and media for the global medical aesthetic industry.",
  cta: { label: "About Medical Insight", to: "/p/about-us" },
} as const;

export const RESEARCH = {
  kicker: "Strategic Market Research",
  title: "A comprehensive portfolio of research reports",
  lede: "For more than 25 years, Medical Insight has tracked both key players and emerging enterprises, providing comprehensive, in-depth coverage of technology and business trends not available elsewhere. With unique access to global market information as a result of its aesthetic publishing and live events, Medical Insight delivers current, detailed analyses and forecasts that are used by many of the industry's top decision makers to identify competitive positions of other major players.",
  cta: { label: "Browse the catalogue", to: "/research" },
} as const;

export const INSIGHTS = {
  kicker: "Aesthetic Insights",
  title: "In-depth reporting on the business of beauty",
  lede: "The only industry news report focused on strategic business development and global market growth, drawing on market research produced exclusively by Medical Insight.",
  cta: { label: "Read Aesthetic Insights", to: "/news" },
} as const;

export const AIA = {
  kicker: "The Aesthetic Industry Association",
  title: "The only dedicated association serving the $23 billion global industry",
  lede: "The Aesthetic Industry Association (AIA) is the first and only member-driven organization dedicated to the long-term health, sustainability and development of the $23 billion medical aesthetic industry.",
  stat: { value: "$23B", label: "Global industry served" },
  cta: { label: "About the association", to: "/p/industry-association" },
  ctaSecondary: { label: "Advisory board", to: "/board" },
} as const;

export const AWARDS = {
  kicker: "AIA Awards",
  title: "Recognizing the year's best work",
  lede: "The Aesthetic Industry Association is sponsoring The Aesthetic Industry Association Awards. Based on the rapid pace of innovation in our industry, the AIA Board of Advisors has decided to review all of the new products and business models launched over the past year to select only the best to win these prestigious awards.",
  cta: { label: "See the awards", to: "/awards" },
} as const;

export const FILM = {
  kicker: "Film",
  title: "Medical Insight in ninety seconds",
  lede: "A short introduction to who we are and the market we cover.",
  /** Rehosted into our own media bucket so it survives the legacy site. */
  src: "/media/cms-images/mii-sizzle-reel.mp4",
  poster: "/media/cms-images/mii-sizzle-poster.jpg",
  /** Shown beside the video — accessibility, and what the prerenderer indexes. */
  synopsis:
    "A montage of Medical Insight's research, editorial and event work across the global medical aesthetic industry, featuring footage from The Beauty Show and Aesthetic Industry Association gatherings.",
} as const;

export const NEWSLETTER = {
  kicker: "Stay current",
  title: "Aesthetic Insights, in your inbox",
  lede: "Industry reporting and analysis from the Medical Insight editorial team.",
  submit: "Subscribe",
} as const;

export const STATS: { value: string; label: string }[] = [
  { value: "1993", label: "Founded" },
  { value: "$23B", label: "Industry covered" },
  { value: "30+", label: "Years of data" },
  { value: "Global", label: "Reach & reporting" },
];
